import { render, staticRenderFns } from "./CustomerContactAdd.vue?vue&type=template&id=5fc2d3f8"
import script from "./CustomerContactAdd.vue?vue&type=script&lang=js"
export * from "./CustomerContactAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports